export default __webpack_public_path__ + "static/lionStudios-7dcd31191e05960276fedfc47318af37.svg";